import React from "react";
import { motion } from "framer-motion";

function AuditHero() {
  return (
    <section
      style={{
        background:
          "linear-gradient(180deg,#00152d 0%,#002147 100%)",
        padding: "140px 24px 120px",
        position: "relative",
        overflow: "hidden"
      }}
    >
      <div
        style={{
          position: "absolute",
          width: "500px",
          height: "500px",
          borderRadius: "50%",
          background:
            "rgba(33,181,115,.10)",
          filter: "blur(140px)",
          top: "-250px",
          right: "-150px"
        }}
      />

      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          position: "relative",
          zIndex: 2
        }}
      >
        <motion.div
          initial={{
            opacity: 0,
            y: 30
          }}
          animate={{
            opacity: 1,
            y: 0
          }}
        >
          <span
            style={{
              color: "#21b573",
              fontWeight: 700,
              textTransform:
                "uppercase",
              letterSpacing: "1px"
            }}
          >
            Complimentary Growth Audit
          </span>

          <h1
            style={{
              color: "#fff",
              fontWeight: 700,
              lineHeight: 1.05,
              marginTop: "20px",
              marginBottom: "24px",
              fontSize:
                "clamp(3rem,6vw,5.5rem)",
              maxWidth: "850px"
            }}
          >
            Discover What's Holding
            Your Growth Back.
          </h1>

          <p
            style={{
              color:
                "rgba(255,255,255,.75)",
              maxWidth: "750px",
              lineHeight: 1.9,
              fontSize: "1.1rem"
            }}
          >
            Receive a strategic review
            of your digital presence,
            uncover missed opportunities,
            identify growth bottlenecks
            and get practical
            recommendations tailored
            to your business.
          </p>
        </motion.div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(220px,1fr))",
            gap: "20px",
            marginTop: "60px"
          }}
        >
          {[
            "SEO Analysis",
            "Website Performance",
            "Lead Generation Review",
            "Growth Recommendations"
          ].map((item) => (
            <motion.div
              key={item}
              whileHover={{
                y: -8
              }}
              style={{
                background:
                  "rgba(255,255,255,.05)",
                border:
                  "1px solid rgba(255,255,255,.08)",
                borderRadius: "24px",
                padding: "24px",
                backdropFilter:
                  "blur(12px)"
              }}
            >
              <div
                style={{
                  color: "#fff",
                  fontWeight: 600
                }}
              >
                {item}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AuditHero;